angular.module('cfn').directive('cfnInputDatedaymonth', [
  'languageService',
  function(languageService) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        afterLink: '=',
        beforeLink: '=',
        class: '@',
        readonly: '=',
        required: '@',
        change: '&',
        isdisabled: '&'
      },
      replace: true,
      template:
        '<input type="text" cfn-enter-tab ng-disabled="isdisabled()" class="{{class}}" show-weeks="false" ng-class="{\'validate[required]\':required&&(readonly!=true)}"  ng-readonly="readonly" ng-required="{{required}}"/>',
      link: function(scope, element) {
        var dayMonthDateFormat = languageService
          .getDatePickerConfig()
          .dateFormat // Remove the year part, as we are only interested in day and month
          .replace(/([\s]{0,1}y+[\s]{0,1})/, '');

        //var datepickerConfig = calendarService.getDatePickerConfig();
        //$.datepicker.setDefaults(datepickerConfig);
        scope.$watch(
          'model',
          function() {
            // init special datepicker
            element.datepicker({
              changeMonth: true,
              changeYear: false,
              showButtonPanel: true,
              dateFormat: dayMonthDateFormat,
              beforeShow: function(input, inst) {
                // add class of datepicker to ensure the ability to hide year;
                $('#ui-datepicker-div').addClass('cfnInputDayMonth');
              },
              onClose: function(input, inst) {
                // remove class to enable normal datepickers
                $('#ui-datepicker-div').removeClass('cfnInputDayMonth');
              }
            });
            if (scope.model) {
              var date = new Date(scope.model);
              //update datepicker
              if (date != element.datepicker('getDate')) {
                element.datepicker('setDate', date);
              }
            } else {
              element.datepicker('setDate', null);
            }
          },
          false
        );

        element.change(function() {
          ang.apply(scope, function() {
            //try{
            var date = element.datepicker('getDate');
            if (date) {
              // if valid date
              scope.model = date.getTime();
            } else {
              scope.model = null;
            }
            if (scope.required) {
              element.validationEngine('validate');
            }
          });
          ang.apply(scope, function() {
            scope.change();
          });
        });
      }
    };
  }
]);
